import { render, staticRenderFns } from "./SponsorJoboffers.vue?vue&type=template&id=8b143d16&"
import script from "./SponsorJoboffers.vue?vue&type=script&lang=js&"
export * from "./SponsorJoboffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports